var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isWhite)?_c('img',{style:(_vm.style),attrs:{"src":require("@/assets/img/icon/create-memo-icon-white.png")}}):_c('img',{style:(_vm.style),attrs:{"src":require("@/assets/img/icon/create-memo-icon.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }